import React from "react"
import styled from "styled-components"
import media from "../styles/media"
import ContentWidth from "./ContentWidth"
// import colors from '../styles/colors'
import text from "styles/text"

const LongFormText = ({ content }) => {
  return (
    <ContentWidth>
      <LongFormTextBlock
        dangerouslySetInnerHTML={{ __html: content.bodyCopy }}
      />
    </ContentWidth>
  )
}

const LongFormTextBlock = styled.div`
  width: 79.444vw;

  ${media.fullWidth} {
    width: 1144px;
  }
  ${media.tablet} {
    width: 92.188vw;
  }
  ${media.mobile} {
    width: 87.85vw;
  }

  h1 {
    ${text.h1};
  }
  h2 {
    ${text.h3};
  }
  h3 {
    ${text.h3};
    margin-top: 3.505vw;

    ${media.fullWidth} {
      margin-top: 15px;
    }

    ${media.tablet} {
      margin-top: 1.465vw;
    }

    ${media.mobile} {
      margin-top: 3.505vw;
    }
  }
  h4 {
    ${text.h3};
  }
  h5 {
    ${text.h5};
    margin-top: 1.389vw;

    ${media.fullWidth} {
      margin-top: 20px;
    }

    ${media.tablet} {
      margin-top: 1.953vw;
    }

    ${media.mobile} {
      ${text.h4};
      margin-top: 4.673vw;
    }
  }

  p,
  li {
    ${text.bodyMd};
    margin-top: 1.042vw;

    ${media.fullWidth} {
      margin-top: 15px;
    }

    ${media.tablet} {
      margin-top: 1.465vw;
    }

    ${media.mobile} {
      margin-top: 3.505vw;
    }
  }

  ul,
  ol {
    margin-left: 3.472vw;
    margin-top: 1.042vw;

    ${media.fullWidth} {
      margin-left: 50px;
      margin-top: 15px;
    }

    ${media.tablet} {
      margin-left: 4.883vw;
      margin-top: 1.465vw;
    }

    ${media.mobile} {
      margin-left: 11.682vw;
      margin-top: 3.505vw;
    }
  }

  img {
    height: auto;
    width: 100%;
  }
`

export default LongFormText
